import React from 'react';
import PropTypes from 'prop-types';
import {Toolbar, Grid, Typography, Button} from '@material-ui/core';
import {Cancel, Save} from '@material-ui/icons';

function CustomiseProjectToolbar(props) {
  const {importedProject, onClickSaveBtn} = props;

  return (
    <Toolbar>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h5" style={{color: 'grey'}}>
            {importedProject.cnsObject.name}{' '}
          </Typography>
        </Grid>
        <Grid item>
          <Grid container spacing={3}>
            <Grid item>
              <Button
                startIcon={<Save />}
                variant="contained"
                onClick={onClickSaveBtn}
                color="primary"
              >
                Save
              </Button>
            </Grid>
            <Grid item>
              <Button startIcon={<Cancel />} variant="outlined" href="#/">
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Toolbar>
  );
}

CustomiseProjectToolbar.propTypes = {
  importedProject: PropTypes.object.isRequired,
  onClickSaveBtn: PropTypes.func.isRequired,
};

export default CustomiseProjectToolbar;
